import "../styles/ConfirmationPage.css"

function ConfirmationPage() {
    return (
        <>
            <section className="confirmation-page">
                <section className="container">
                    <h2>Your booking confirmed!</h2>
                </section>
            </section>
        </>
    );
}

export default ConfirmationPage;
